export default "__VITE_ASSET__CfaSZFZa__"